import { createFileRoute, notFound } from '@tanstack/react-router';
import { CreationDetailRoute } from '@/components/custom/creation-detail-route';
import { websiteConfig } from '@/config/website';
import { m } from '@/locale/paraglide/messages';
import { seo } from '@/lib/seo';
import { authRouteMiddleware } from '@/middlewares/auth-middleware';

export const Route = createFileRoute('/creation/$id')({
  server: {
    middleware: [authRouteMiddleware],
  },
  loader: async ({ params, context }) => {
    const { getCreation } = await import('@/api/creation');
    const item = await getCreation({ data: { id: params.id } });
    if (!item) throw notFound();
    // Seed React Query cache so the image editor page's useQuery hits instantly.
    context.queryClient.setQueryData(['creationDetail', params.id], item);
    return item;
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const siteName = websiteConfig.metadata?.name ?? '';
    const title = siteName
      ? `${m.creation_detail_meta_title()} | ${siteName}`
      : m.creation_detail_meta_title();
    return seo(`/creation/${loaderData.id}`, {
      title,
      description: loaderData.prompt.slice(0, 160),
    });
  },
  component: CreationDetailRoute,
});
